import React from "react";
const PluginsEventsContext = React.createContext(
  null
);
const PluginsEventsContextProvider = ({
  pluginsEvents,
  children
}) => /* @__PURE__ */ React.createElement(PluginsEventsContext.Provider, { value: pluginsEvents }, children);
export {
  PluginsEventsContext,
  PluginsEventsContextProvider
};
//# sourceMappingURL=plugins-events-context.js.map
